<template>
  <div id="Workflow" class="row csp-card">
    <div class="container-fluid">
      
      <div v-if="heading !== undefined" class="row csp-margin-top">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ">
          <p class="csp-account-id">{{ heading }}</p>
        </div>
      </div>
      
      <div class="row">
        <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <div class="card">
            <!--Card content-->
            <div class="card-block container-fluid">
                <div class="row" v-if="backRoute !== undefined">
                  <div class="col-xs-12 csp-back-link-container">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    <router-link v-bind:to="backRoute" class="csp-back-link-text" >{{ backNavLink }}</router-link>
                  </div>                
                </div>
                
                <router-view></router-view>
                
                <div class="row">
                  <div class="col-xs-12 ">
                    <!-- TODO change the router link to and the button text to reference the workflow settings for the current page -->
                    <div v-show="!allInputValid || loading" class="btn btn-disabled csp-btn-continue">
                      <span>{{ navButton }}</span>
                    </div>
                    <div v-show="allInputValid && !loading">
                      <router-link v-bind:to="nextRoute" class="btn btn-primary primary-color csp-btn-continue" >{{ navButton }}</router-link>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <progress-dots v-bind:totalSteps="workflowSteps" v-bind:currentStep="currentStep"></progress-dots>
                  <loading v-bind:loading="loading"></loading>
                </div>
            </div>
            <!--/.Card content-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProgressDots from '../components/ProgressDots'
  import Loading from '../components/Loading'
  import {mainPage} from '../router'
  
  export default {
    name: 'Workflow',
    components: {
      ProgressDots,
      Loading
    },
    data: function () {
      return {
        loading: false
      }
    },
    computed: {
      nextRoute: function () {
        return this.$route.meta.nextRoute || mainPage
      },
      backRoute: function () {
        return this.$route.meta.backRoute
      },
      workflowSteps: function () {
        return this.$route.meta.workflowSteps
      },
      currentStep: function () {
        return this.$route.meta.currentStep
      },
      navButton: function () {
        return this.$route.meta.navButton
      },
      backNavLink: function () {
        return this.$route.meta.backNavLink
      },
      heading: function () {
        return this.$route.meta.heading
      },
      allInputValid: function () {
        const inputValid = this.$route.meta.inputValid

        if (inputValid === undefined) return true
        if (typeof (inputValid) === 'boolean') return inputValid
        if (typeof (inputValid) === 'string') return this.$store.getters[inputValid]

        console.warn('Unexpected input validation type: %s', inputValid)
        return true
      }
    },
    methods: {
      clearLoading: function () {
        this.loading = false
      },
      setLoading: function () {
        this.loading = true
      }
    },
    beforeRouteLeave (to, from, next) {
      if (typeof (this.$route.meta.beforeRouteLeave) === 'function') this.$route.meta.beforeRouteLeave(to, from, next, this)
      else next()
    }
  }
</script>

<style scoped>
  .csp-back-link-container{
    margin-top:1em;
  }

  .csp-back-link-text {
    color: black;
    font-weight:bold;
    cursor: pointer;
  }

  .csp-margin-top{
    margin-top: 4vh;
  }
  
  .csp-account-id{
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 1.15;
    color: #FCFCFC;
    opacity: 1.00;
    text-shadow: 2px 2px #555;
  }
  
  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// Workflow.vue?7d5ca5d2